import Text from "../../../../styleguide/Text";
import ActionMenu from "../../../../components/actionMenu/ActionMenu";
import useRoutesHelper from "../../../../hooks/useRoutesHelper";
import { useAppDispatch } from "../../../../redux/hooks";
import { openAddNodeModal } from "../../../../redux/reducer/expedition.reducer";

function CustomHeaderInternodeRouteNodes({
  denumireNod,
  className,
}: {
  className?: string;
  denumireNod?: string;
}) {
  const dispatch = useAppDispatch();
  const { routeMainParam } = useRoutesHelper();

  const idInternod = routeMainParam.clientId;

  const handleAddNewNode = () => {
    if (idInternod) {
      dispatch(openAddNodeModal());
    }
  };

  return (
    <div className={`${className} flex justify-between gap-4`}>
      <Text
        variant="h3"
        component="h3"
        className="mb-4 font-semibold text-slate-900"
        gutterBottom>
        Noduri traseu {denumireNod}
      </Text>
      <ActionMenu
        items={[
          {
            id: "add-node",
            label: "Adauga nod",
            icon: "ADD",
            tooltip: idInternod
              ? "Deschide adaugarea unui nod pe aceasta ruta."
              : "Ruta trebuie sa aiba un identificator pentru a adauga un nod.",
            disabled: !idInternod,
            onClick: handleAddNewNode,
          },
        ]}
        title={denumireNod}
        ariaLabel={`Actiuni pentru ruta ${denumireNod ?? ""}`}
      />
    </div>
  );
}

export default CustomHeaderInternodeRouteNodes;
